import { toast } from "react-toastify";
import { BasicPage } from "../../../theme/Component/BasicPage"
import { ListMenu } from "../../../theme/Component/ListMenu";
import { useEffect, useState } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _BusinessProcess, _Machines, _single } from "../../../../core/services/dataBean/EntityCatalog";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { SelectConstantsValue } from "../../../theme/Component/SelectConstantsValue";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { EditorFixedAssetItem } from "../../../contract/etapa-contrato/contrac/ublinvoice/FixedAssetItem/EditorFixedAssetItem";
import useModal, { MODAL_md, MODAL_XL } from "../../../theme/Component/hooks/useModal";
import { FileInput } from "../../../theme/Component/FileInput";
import { DepartamentCitiesEditor } from "../../../../portal/componets/pages/IndexPage/Components/PersonarDataUser/Components/DepartamentCitiesEditor";
import { RequestMaintenance } from "../RequestMaintenance/RequestMaintenance";
import { ImportXLSX } from "../../../theme/Component/ImportXLSX";

interface Form {
    State: number;
    Location: number;
}

export const Machines = () => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_Machines);
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ name: 'Eliminar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [form, setForm] = useState<Partial<Form>>({
        State: 1
    })
    const [request, setRequest] = useState<any>({});
    const modalRequest = useModal("Iniciar Solicitud de Mantenimiento", MODAL_md);
    const modalHistory = useModal(`Historial de mantenimiento de ${bean.Description}`, MODAL_XL);

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {
        const props = {
            State: form.State,
            IDLocation: form.Location
        }
        instance.getMachinesCatalogPorPropiedades(props, null).then(
            (resp: any) => {
                if (resp) {
                    resp.forEach(element => {
                        const dataItem = element.DataBeanProperties;
                        dataItem.RenderState = renderState(dataItem.State)
                    });
                    setLista(resp)
                }
            }
        )
    }



    const create = () => {
        setBean({
            State: 1,
            IDEmployee: _single.getAccountID(),
        });
        setModal({ ...modal, "name": `Agregar Maquinaria`, "view": true });
    }

    const deleteItem = () => {
        const x = { ...bean, State: 3 };
        editaItem(x);
        setModalC({ ...modalC, view: false });
    };


    const editaItem = (obj: any) => {
        //console.log(abilityType.bean);
        instance.updateMachines(obj).then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const head = [
        { title: 'ID', property: 'IDMachines', visible: true },
        { title: 'Codigo', property: 'CodeMachine', visible: true },
        { title: 'Nombre', property: 'Description', visible: true },
        { title: 'Marca', property: 'Brand', visible: true },
        { title: 'Modelo', property: 'Model', visible: true },
        { title: 'Serial', property: 'Serial', visible: true },
        { title: 'Departamento', property: 'RenderRegion', visible: true },
        { title: 'Ciudad', property: 'RenderCity', visible: true },
        { title: 'Tipo de Mantenimiento', property: 'RenderTypeMaintenanceMachine', visible: true },
        { title: 'Ubicación', property: 'IDLocationRender', visible: true },
        { title: 'Estado', property: 'RenderState', visible: false },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create },
        { nombre: 'Importar Items', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: () => { modalImport.open() } }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },
            { titulo: 'Solicitar Mantenimiento', icono: 'ri-settings-5-fill', visible: true, evento: () => { setRequest({}); modalRequest.open() } },
            { titulo: 'Historial de Mantenimientos', icono: 'ri-history-line', visible: _single.canDelete(), evento: () => { modalHistory.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const renderState = (State: number) => {
        switch (State) {
            case 1:
                return "Funcionando";
            case 2:
                return "Mantenimiento";
            case 3:
                return "Eliminada";
        }
    }

    const modalImport = useModal("Importar", MODAL_md);
    const [listImport, setListImport] = useState([]);


    const importMenu = async () => {
        console.log(listImport);
        let existe: string[] = [];
        let errores: number[] = [];

        lista.forEach(element => {
            const code = element.DataBeanProperties.CodeMachine;
            if (code && typeof code === "string") {
                existe.push(code.trim());
            }

        });

        for (let index = 1; index < listImport.length; index++) {
            let row = listImport[index];

            const idItem = row[0];
            const description = row[1];

            if (!idItem || !description) {
                toast.warning(`Falta IDItem o Descripción en la fila ${index + 1}`);
                errores.push(index + 1);
                continue;
            }

            if (!existe.includes(row[2])) {
                let obj = {
                    IDItem: row[0],
                    Description: row[1],
                    CodeMachine: row[2],
                    Serial: row[3],
                    Model: row[4],
                    Brand: row[5],
                    State: 1
                };

                try {
                    await instance.updateMachines(obj).then(
                        (resp) => {
                            toast.success(`Maquina creada en la fila ${index + 1}`)
                        }
                    )
                } catch (err) {
                    console.log(`Error en la fila ${index}:`, err);
                    toast.error(`Error al crear el item en la fila ${index}`);
                    errores.push(index);
                }
            }
        }

        // fin del proceso

        await getLista();

        setModal({ ...modal, "view": false });

        modalImport.close();

        if (errores.length > 0) {
            alert(`Error en los siguientes índices: ${errores.join(", ")}`);
        }
    };


    return (
        <BasicPage titulo="Maquinaria">
            <div className="row">
                <div className="col-md-5">
                    <SelectConstantsValue
                        returnType="Object"
                        label="Ubicación"
                        code={26}
                        onChange={(e: any) => { setBean({ ...bean, 'IDLocation': e?.CodeID, IDLocationRender: e?.Name }); console.log(e) }}
                        value={bean.IDLocation}
                    />
                </div>
                <div className="col-md-5">
                    <label>Estado</label>
                    <select className="form-select" value={form.State} onChange={(e) => {
                        const value = e.target.value ? Number(e.target.value) : null;
                        setForm({ ...form, State: value })
                    }} >
                        <option value="">...</option>
                        <option value={1}>Funcionando</option>
                        <option value={2}>En Mantenimiento</option>
                    </select>
                </div>
                <div className="col-md-2 mt-4">
                    <BasicButton eventClick={getLista} icon="ri-search-line" children={"buscar"} />
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} />

                    <Modal modal={modal} updateModal={setModal} eventModal={() => { editaItem(bean) }}>
                        <div className="row">
                            <div className="col-md-12">
                                <FileInput
                                    previsualization
                                    Media={bean.MediaMachine}
                                    MediaContext={bean.MediaContext}
                                    docAcept="image/jpeg, image/png, image/gif, image/bmp, image/tiff, image/svg+xml"
                                    onCreate={(e) => { setBean({ ...bean, MediaMachine: e.Media, MediaContext: e.MediaContext }) }}
                                />
                            </div>
                            <div className="col-md-12">
                                <label>Maquina</label>
                                <EditorFixedAssetItem idSelector={bean.IDItem} label="" onChange={(e) => { setBean({ ...bean, IDItem: e.IDItem, Description: e.Name }) }} />
                            </div>
                            <div className="col-md-12">
                                <label>Descripción de la Maquina</label>
                                <input type="text" name="Description" className="form-control" disabled value={bean.Description} onChange={(e) => { setBean({ ...bean, Description: e.target.value }) }} />
                            </div>
                            <div className="col-md-12">
                                <label>Codigo Interno</label>
                                <input type="text" name="CodeMachine" className="form-control" value={bean.CodeMachine} onChange={(e) => { setBean({ ...bean, CodeMachine: e.target.value }) }} />
                            </div>
                            <div className="col-md-12">
                                <label>Serial de la Maquina</label>
                                <input type="text" name="Serial" className="form-control" value={bean.Serial} onChange={(e) => { setBean({ ...bean, Serial: e.target.value }) }} />
                            </div>
                            <div className="col-md-12">
                                <label>Modelo de la Maquina</label>
                                <input type="text" name="Model" className="form-control" value={bean.Model} onChange={(e) => { setBean({ ...bean, Model: e.target.value }) }} />
                            </div>
                            <div className="col-md-12">
                                <label>Marca de la Maquina</label>
                                <input type="text" name="Brand" className="form-control" value={bean.Brand} onChange={(e) => { setBean({ ...bean, Brand: e.target.value }) }} />
                            </div>
                            <div className="col-md-12">
                                <DepartamentCitiesEditor idSelector={bean.IDCity} onChange={(e) => {
                                    console.log(e)
                                    setBean({ ...bean, IDCity: e.IDCities, RenderCity: e.Ciudad, IDRegion: e.IDStates, RenderRegion: e.Departamento })
                                }} label="Ubicación de la maquina" />
                            </div>
                            <div className="col-md-12">
                                <SelectConstantsValue
                                    returnType="Object"
                                    label="Tipo de Mantenimiento de la Maquina"
                                    code={28}
                                    onChange={(e: any) => { setBean({ ...bean, IDTypeMaintenanceMachine: e?.CodeID, RenderTypeMaintenanceMachine: e?.Name }); }}
                                    value={bean.IDTypeMaintenanceMachine}
                                />
                            </div>
                            <div className="col-md-12">
                                <SelectConstantsValue
                                    returnType="Object"
                                    label="Ubicación"
                                    code={26}
                                    onChange={(e: any) => { setBean({ ...bean, 'IDLocation': e?.CodeID, IDLocationRender: e?.Name }); console.log(e) }}
                                    value={bean.IDLocation}
                                />
                            </div>
                            <div className="col-md-12">
                                <label>Estado</label>
                                <select className="form-select" value={bean.State} onChange={(e) => {
                                    const value = e.target.value ? Number(e.target.value) : null;
                                    setBean({ ...bean, State: value })
                                }} >
                                    <option value="">...</option>
                                    <option value={1}>Funcionando</option>
                                    <option value={2}>En Mantenimiento</option>
                                </select>
                            </div>
                        </div>
                    </Modal>

                    <Modal modal={modalRequest.modal} updateModal={modalRequest.setModal} eventModal={() => {  }} >
                        <div className="row">
                            <div className="col-md-12">
                                <label>Justificación</label>
                                <textarea className="form-control" value={request.Obs} onChange={(e) => { setRequest({ ...request, Obs: e.target.value }) }} />
                            </div>

                        </div>
                    </Modal>

                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {bean.Description}</strong>
                    </ModalConfirm>

                    <Modal modal={modalHistory.modal} updateModal={modalHistory.setModal} >
                        <div className="row">
                            <div className="col-md-12">
                                <RequestMaintenance isModal filterProps={{ IDMachines: bean.IDMachines }} />
                            </div>
                        </div>
                    </Modal>

                    <Modal modal={modalImport.modal} updateModal={modalImport.setModal} eventModal={importMenu} onSubmitLabel="Importar">
                        <div className="row">
                            <div className="col">
                                <ImportXLSX lodaData={setListImport} />
                            </div>
                        </div>
                    </Modal>
                </div>

            </div>
        </BasicPage>
    )
}